import { render, staticRenderFns } from "./PlayBar.vue?vue&type=template&id=5df573b2&scoped=true"
import script from "./PlayBar.vue?vue&type=script&lang=js"
export * from "./PlayBar.vue?vue&type=script&lang=js"
import style0 from "./PlayBar.vue?vue&type=style&index=0&id=5df573b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df573b2",
  null
  
)

export default component.exports